import and from './and'
import not from './not'
import or from './or'
import pathnameIncludesAfterKey from './pathnameIncludesAfterKey'
import pathnameIncludesOne from './pathnameIncludesOne'
import referrerExists from './referrerExists'
import referrerIncludesPlatform from './referrerIncludesPlatform'
import referrerIsSameAsSite from './referrerIsSameAsSite'
import searchParamEqualsOne from './searchParamEqualsOne'
import searchParamIncludesOne from './searchParamIncludesOne'

export default {
  and,
  not,
  or,
  pathnameIncludesAfterKey,
  pathnameIncludesOne,
  referrerExists,
  referrerIncludesPlatform,
  referrerIsSameAsSite,
  searchParamEqualsOne,
  searchParamIncludesOne,
}



// WEBPACK FOOTER //
// ./provolution/app/views/provolution/jsCore/organizedByType/vms/ads/trafficAnalyzer/predicates/index.js